/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/button/custom-elements';

import { defineCustomElement as defineOsdsButton } from '@ovhcloud/ods-stencil/components/button/custom-elements/osds-button.js';

export const OsdsButton = /*@__PURE__*/createReactComponent<JSX.OsdsButton, HTMLOsdsButtonElement>('osds-button', undefined, undefined, defineOsdsButton);
